<template>
  <div>
    <div class="container" id="appointment">
      <div v-if="loading">
        <b-spinner variant="primary" label="Spinning" style="margin-top: 100px;"></b-spinner>
      </div>
      <div class="row" v-if="!loading">
        <div class="col-6" v-for="(sd, dtype) in timeSettings" :key="dtype">
          <MainTimeDisplay
            :isWeekday="dtype=='weekday'"
            v-model="timeSettings[dtype]"
            :key="'data-' + dtype"
            v-on:removeTime="RemoveAvalTime"
          />
        </div>
      </div>
    </div>
    <div class="container time-control-buttons" v-if="!loading">
      <div class="row">
        <div class="col-2">
          <div class="btnAddT">
            <b-button variant="outline-primary" v-b-modal.addtimeModal type="button">Add time</b-button>
          </div>
        </div>
        <div class="col-8">
          <div id="btnUpload" style="margin: auto;">
            <b-button
              v-b-modal.modal-confirm
              type="button"
              variant="primary"
              data-toggle="modal"
              v-on:click="uploadTime()"
              size="lg"
            >Update Time</b-button>

            <b-modal id="modal-confirm" title="Time Update" ok-only>
              <p class="my-4">{{timeUpdRes}}</p>
            </b-modal>
          </div>
          <div class="col-2"></div>
          <!-- </div> -->
        </div>
        <div class="col-2">
          <div class="btnAddT">
            <b-button variant="outline-primary" v-b-modal.daysOffScreen type="button">Set days Off</b-button>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <b-modal
      id="daysOffScreen"
      title="Select the days off"
      ok-title="Set Days Off"
      @ok="setDaysOff()"
      @hidden="resetDaysOff()"
      cancel-title="Close"
      size="lg"
    >
      <!-- @context="addToDaysOffArr()" -->
      <div class="row">
        <div class="col-6">
          <b-calendar
            v-model="dayOffSelected"
            @selected="addToDaysOffArr()"
            @context="resetDayOffCounter"
            :date-info-fn="offDateClass"
            locale="en-US"
            selected-variant="danger"
          ></b-calendar>
        </div>

        <div class="col-6" v-if="dayOffSelected == ''">
          <p
            style="margin-top: 60px; font-size:24px; font-weight:bold; color: rgb(3, 0, 153)"
          >Select a Day Off date</p>
        </div>

        <div class="col-6" v-if="dayOffSelected != ''">
          <div class="row dayOffReasonHead">
            <div class="col-12">
              <p style="margin-bottom:0px;">Day Off reason for</p>
              <strong>{{new Date(dayOffSelected + "T12:00:00-00:00").toDateString()}}</strong>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-form-input
                v-model="daysOff[dayOffSelected]"
                placeholder="Enter day off reason"
                style="font-size: 1rem;"
              ></b-form-input>
            </div>
          </div>
          <div id="botDOffReason" class="row" style="margin-top:20px;">
            <div class="col-12">
              <p>Bot answer will look like:</p>
              <p
                v-if="daysOff[dayOffSelected]"
              >"Sorry, we are not working on {{new Date(dayOffSelected).toDateString()}} because of {{daysOff[dayOffSelected]}}"</p>
              <p v-else>"Sorry, {{new Date(dayOffSelected).toDateString()}} is our day off"</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="addtimeModal"
      title="Enter time"
      ok-title="Add time"
      @ok="addTime"
      cancel-title="Close"
      :ok-disabled="newTimeErr != ''"
    >
      <div class="row ntimeStyle">
        <div class="col-3">Hours</div>
        <div class="col-2"></div>
        <div class="col-3">Minutes</div>
        <div class="col-1"></div>
        <div class="col-3">AM/PM</div>
      </div>
      <div class="row" style="margin: 5px 0 15px 0;">
        <div class="col-12">
          <SetTimeBox key="addTimeCtrl" v-model="timeToAdd" title :allowed="true" addclass />
        </div>
      </div>
      <div class="row">
        <div
          class="col-12"
          :style="newTimeErr != '' ? 'color:darkred' : 'color: green'"
        >{{newTimeErr || 'Looks good! Ready to add:)'}}</div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";
import MainTimeDisplay from "./TimeControlComponents/MainTimeDisplay.vue";
import SetTimeBox from "./additionalComponents/SetTimeBox.vue";

export default {
  name: "TimeControl",
  components: {
    MainTimeDisplay,
    SetTimeBox
  },
  props: {
    currAdmin: Object,
    admins: Array
  },
  data() {
    return {
      timeSettings: {},
      timeToAdd: {},
      loading: true,
      daysOff: {},
      savedSettings: {},
      timeUpdRes: "",
      dayOffSelected: "",
      daysOffCounter: {}
    };
  },

  created() {
    this.GetAvalTimes();
  },
  computed: {
    newTimeErr() {
      let r = "";
      if (
        this.timeToAdd.hours &&
        this.timeToAdd.minutes &&
        this.timeToAdd.ampm
      ) {
        if (
          this.timeSettings.weekday.find(
            el =>
              el.time ==
              `${this.timeToAdd.hours}:${this.timeToAdd.minutes}${this.timeToAdd.ampm}`
          )
        ) {
          r = `You already have ${this.timeToAdd.hours}:${this.timeToAdd.minutes}${this.timeToAdd.ampm} on your list;)`;
        }
      } else {
        r = `Select ${this.timeToAdd.hours ? "" : "hours"}${
          this.timeToAdd.minutes
            ? ""
            : !this.timeToAdd.hours
            ? ", minutes"
            : "minutes"
        }${
          this.timeToAdd.ampm
            ? ""
            : !this.timeToAdd.hours || !this.timeToAdd.minutes
            ? " and AM/PM"
            : "AM/PM"
        } please`;
      }

      return r;
    }
  },

  methods: {
    RemoveAvalTime: function(vl) {
      let k = this.timeSettings.weekday.findIndex(el => el.time == vl);
      if (k > -1) {
        this.timeSettings.weekday.splice(k, 1);
        this.timeSettings.weekend.splice(k, 1);
      }
    },
    setDaysOff() {
      this.savedSettings.daysOff = new Object();
      this.savedSettings.daysOff = Object.assign(
        {},
        this.savedSettings.daysOff,
        this.daysOff
      );
      this.dayOffSelected = "";

      firebase
        .firestore()
        .doc(`available_hours/${this.currAdmin.location}`)
        .update({ daysOff: this.savedSettings.daysOff });
    },

    offDateClass(ymd, date) {
      let mnth = date.getMonth() + 1;
      let day = date.getDate();
      let dateFormated = `${date.getFullYear()}-${
        mnth < 10 ? "0" + mnth : mnth
      }-${day < 10 ? "0" + day : day}`;

      return this.daysOff[dateFormated] != undefined ? "table-danger" : "";
    },

    resetDaysOff() {
      this.daysOff = new Object();
      this.daysOff = Object.assign(
        {},
        this.daysOff,
        this.savedSettings.daysOff
      );
      this.dayOffSelected = "";
    },

    resetDayOffCounter() {
      for (let fy in this.daysOffCounter) {
        this.daysOffCounter[fy] = 0;
      }
    },

    addToDaysOffArr() {
      if (this.dayOffSelected != "") {
        if (this.daysOff[this.dayOffSelected] != undefined) {
          if (this.daysOffCounter[this.dayOffSelected] > 0) {
            this.$delete(this.daysOff, this.dayOffSelected);
          } else {
            this.$set(this.daysOffCounter, this.dayOffSelected, 1);
          }
        } else {
          this.$set(this.daysOff, this.dayOffSelected, "");
          this.$set(this.daysOffCounter, this.dayOffSelected, 1);
        }
      }
    },

    dbDataProcess() {
      ["weekday", "weekend"].forEach(key => {
        this.$set(this.timeSettings, key, []);

        this.savedSettings.all_times.forEach(el => {
          let ind = this.savedSettings[key].times.findIndex(elem => elem == el);

          this.timeSettings[key].push({
            time: el,
            onoff: ind > -1 ? true : false,
            timeSlots: ind < 0 ? 0 : this.savedSettings[key].time_slots[el],
            prefTime:
              ind < 0 ? false : this.savedSettings[key].button_times[ind]
          });
        });
      });

      this.daysOff = Object.assign(
        {},
        this.daysOff,
        this.savedSettings.daysOff
      );

      this.loading = false;
    },

    GetAvalTimes() {
      let that = this;
      firebase
        .firestore()
        .doc(`available_hours/${this.currAdmin.location}`)
        .get()
        .then(doc => {
          if (!doc.exists) {
            console.log("No such document!");
          } else {
            that.savedSettings = Object.assign(
              {},
              that.savedSettings,
              doc.data()
            );
            that.dbDataProcess();
            // console.log('Document data:', doc.data());
          }
        })
        .catch(err => {
          alert("Failed to load data :(");
          that.loading = false;
          console.log("Error getting document", err);
        });
    },

    uploadTime() {
      this.savedSettings = {
        all_times: [],
        weekday: {
          times: [],
          time_slots: {},
          button_times: []
        },
        weekend: {
          times: [],
          time_slots: {},
          button_times: []
        }
      };
      ["weekday", "weekend"].forEach(key => {
        this.sortTimeArr(key);

        this.timeSettings[key].forEach(el => {
          if (key == "weekday") {
            this.savedSettings.all_times.push(el.time);
          }

          if (el.onoff) {
            this.savedSettings[key].times.push(el.time);
            this.savedSettings[key].button_times.push(el.prefTime);
            this.savedSettings[key].time_slots[el.time] = el.timeSlots;
          }
        });
      });

      let that = this;
      firebase
        .firestore()
        .doc(`available_hours/${this.currAdmin.location}`)
        .update({
          all_times: this.savedSettings.all_times,
          weekday: this.savedSettings.weekday,
          weekend: this.savedSettings.weekend
        })
        .then(function() {
          that.timeUpdRes = "Time was updated successfully";
        })
        .catch(function() {
          that.timeUpdRes = "Failed to updated";
          console.log("error");
        });
    },

    sortTimeArr(ky) {
      this.timeSettings[ky].sort((a, b) =>
        Date.parse(`${this.tmConvert(a.time)}`) <
        Date.parse(`${this.tmConvert(b.time)}`)
          ? -1
          : 1
      );
    },

    addTime() {
      let t = this.timeToAdd;
      let nt = `${t.hours}:${t.minutes}${t.ampm}`;
      if (
        t.hours &&
        t.minutes &&
        t.ampm &&
        !this.timeSettings.weekday.find(el => el.time == nt)
      ) {
        ["weekday", "weekend"].forEach(key => {
          this.timeSettings[key].push({
            time: nt,
            onoff: false,
            timeSlots: 0,
            prefTime: false
          });

          this.sortTimeArr(key);
        });
      }
    },
    tmConvert(t) {
      let ampm = t.substring(t.length - 2, t.length);
      let h = Number(t.split(":")[0]) != 12 ? Number(t.split(":")[0]) : 0;
      return `01/01/2011 ${ampm == "pm" ? h + 12 : h}:${t
        .split(":")[1]
        .replace(ampm, ":00")}`;
    }
  }
};
</script>

<style scoped>
.ntimeStyle {
  font-size: 22px;
  text-align: left;
  margin-top: 15px;
}
.btnAddT {
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
}

#btnUpload {
  text-align: center;
  padding-left: 20px;
  padding-top: 20px;
  padding-bottom: 20px;
}
#appointment {
  overflow-y: auto;
  max-height: 85vh;
}
.time-control-buttons {
  position: sticky;
  bottom: 0px;
  background-color: #fff;
}
.timePref {
  padding-left: 8%;
}
.dayOffReasonHead {
  font-size: 20px;
  padding-top: 30px;
  padding-bottom: 20px;
  color: rgb(3, 0, 153);
}
#botDOffReason p {
  margin-top: 5px;
  margin-bottom: 5px;
}
.btn-outline-primary {
  color: #266db3;
  border-color: #266db3;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #266db3;
  border-color: #266db3;
}
.btn-primary {
  color: #fff;
  background-color: #266db3;
  border-color: #266db3;
}
.btn-primary:hover {
  color: #fffda3;
  background-color: #145a9e;
  border-color: #145a9e;
}

@media (max-width: 992px) {
  .container,
  .container-md,
  .container-sm {
    max-width: 100%;
  }
  .timePref {
    margin-right: 0;
    padding-left: 3%;
    padding-right: 0;
  }
}
</style>